import { ReturnProcessingLevel } from "@redotech/redo-return-settings-primitives-common/return-processing-level";

/** Whether the level assigns grades during processing (drives grade steps and grade actions). */
export function isGradingLevel(
  level: ReturnProcessingLevel | undefined,
): boolean {
  return level === ReturnProcessingLevel.GRADING;
}
